import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-example',
  templateUrl: './message-example.component.html',
  styleUrls: ['./message-example.component.scss'],
})
export class MessageExampleComponent implements OnInit {

  constructor() { }

  @Input() title = '상대에게는 이렇게 문자 메시지가 가요';
  @Input() message = '[내 마음을 몰래 표현해요, 시그널 💓]<br>당신을 좋아하는 누군가가 당신에게 시그널을 보냈어요.';
  @Input() image = 'assets/icons/signal/signal-message.png';


  ngOnInit() {}

}
